import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Cómo trabajamos',
  href: '#como-trabajamos'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Equipo',
  href: '#equipo'
}, {
  label: 'Preguntas',
  href: '#faq'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/98 backdrop-blur-md shadow-sm' : 'bg-white/95 backdrop-blur-sm'} border-b border-slate-200`} data-id="element-136">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-137">
        <div className="flex items-center justify-between" data-id="element-138">
          <a href="#" className="flex items-center" data-id="element-139">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rbqnTT3WAHBizaFCFvc1JL/logo.png" alt="Enlaces Consultora" className="h-12 transition-transform duration-300 hover:scale-105" data-id="element-140" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-141">
            {navItems.map((item, index) => <a key={index} href={item.href} className="relative text-slate-700 hover:text-emerald-600 font-medium transition-colors duration-300 group" data-id="element-142">
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-emerald-600 transition-all duration-300 group-hover:w-full" data-id="element-143"></span>
              </a>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-slate-700 hover:text-emerald-600 transition-colors" data-id="element-144">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-145" /> : <MenuIcon className="w-6 h-6" data-id="element-146" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden pt-4 pb-2" data-id="element-147">
            <div className="flex flex-col space-y-3" data-id="element-148">
              {navItems.map((item, index) => <a key={index} href={item.href} onClick={() => setIsOpen(false)} className="text-slate-700 hover:text-emerald-600 font-medium py-2 transition-colors" data-id="element-149">
                  {item.label}
                </a>)}
            </div>
          </motion.div>}
      </div>
    </nav>;
}